import { render, staticRenderFns } from "./add-user.vue?vue&type=template&id=0824a9c3&scoped=true&"
import script from "./add-user.vue?vue&type=script&lang=js&"
export * from "./add-user.vue?vue&type=script&lang=js&"
import style0 from "./add-user.vue?vue&type=style&index=0&id=0824a9c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0824a9c3",
  null
  
)

export default component.exports